import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";

import type {
  TranslationKey,
  TranslationKeyAndOptions,
} from "@thalamos/vision-common";
import { buildTranslationInput } from "@thalamos/vision-common";

import { Translation } from "../../../Translation/Translation.js";

export function EmptySectionRow({
  label,
  colSpan,
}: {
  label: TranslationKey | TranslationKeyAndOptions;
  colSpan: number;
}) {
  const theme = useTheme();

  return (
    <TableRow className="structural-row">
      <TableCell colSpan={colSpan}>
        <Box
          sx={{
            minHeight: "3rem",
            background: theme.palette.grey[200],
            borderRadius: "0.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              lineHeight: "1.2",
              fontWeight: "bold",
            }}
            variant="caption"
          >
            <Translation {...buildTranslationInput(label)} />
          </Typography>
        </Box>
      </TableCell>
    </TableRow>
  );
}
